export const NON_PO_ITEM = 'nonPoItem'
export const PO_ITEM = 'poItem'

// database CRF schema names
export const ID = '_id'
export const CRF_NO = 'crfNo'
export const CREATION_DATE = 'creationDate'
export const DUE_DATE = 'dueDate'
export const EXPECTED_COMPLETION_DATE = 'expectedCompletionDate'
export const VENDOR = 'vendor'
export const TOTAL_NET_PRICE = 'totalNetPrice'
export const DEPARTMENT = 'department'
export const STATUS = 'status'
export const ACCOUNTING_APPROVER = 'accountingApprover'
export const ACCOUNTING_MANAGER = 'accountingManager'
export const DEPARTMENT_APPROVER = 'departmentApprover'
export const PROJECT = 'project'
export const CHECK_AMOUNT = 'checkAmount'
export const CHECK_NO = 'checkNo'
export const CHECK_DATE = 'checkDate'
export const CHECK_AVAILABLE_DATE = 'checkAvailableDate'
export const DATE_RELEASED = 'dateReleased'
export const PO_NUMBER = 'poNumber'
export const REQUESTOR = 'requestor'
export const PARTICULARS = 'particulars'
export const SUB_PROJECT = 'subProject'
export const REQUEST_TYPE = 'requestType'
export const SUPPORTING_DOCUMENTS = 'supportingDocuments'
export const GL_CATEGORY = 'glCategory'
export const GL_ACCOUNT = 'glAccount'
export const GROSS_PRICE_PER_ITEM = 'grossPricePerItem'
export const VAT_TYPE = 'vatType'
export const W_TAX_TYPE = 'wTaxType'
export const RELEASING_CENTER = 'releasingCenter'
export const PROJECT_CLASSES = 'projectClasses'
